// 获取cookies
export function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) {
      return decodeURIComponent(value); // 解码特殊字符
    }
  }
  return null;
}

// 设置cookies
export function setCookie(
  name,
  value,
  days = 100,
  path = "/",
  domain,
  secure,
  sameSite = "Lax"
) {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  // 过期时间
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    cookieString += `; expires=${date.toUTCString()}`;
  }

  cookieString += `; path=${path}`;
  if (domain) cookieString += `; domain=${domain}`;
  if (secure) cookieString += `; secure`;
  if (sameSite) cookieString += `; samesite=${sameSite}`;

  document.cookie = cookieString;
}
